// src/pages/News.js

import React from 'react';

const News = () => {
  return (
    <div>
      <div className='main'>
        <div className="column1"></div>
        <div className="column2">
          <br />
          <br />
          <div style={{ textAlign: 'center' }}>
          <h1>News</h1>
          </div>
          <br />
          <h3>Delay with BubbleUp</h3>
          <p>TBA: Christmas 2024</p>
          <p>
            Sorry everyone. BubbleUp is delayed. Too much volunteering efforts. Keep a eye out
            this Christmas for release.
          </p>
          <br />
        </div>
        <div className="column3"></div>
      </div>
    </div>
  );
};

export default News;
